import { useEffect, useState } from "react";

import {
  METRIC_PENDING_WINDOW_MS,
  toRecordingMs,
} from "../../utils/results/metricPending";

/**
 * Re-renders the caller exactly once, right when the pending window closes, so a
 * "Calculating…" indicator flips to the empty fallback even if the underlying
 * data never refreshes. No-op when the value is not pending.
 */
export function usePendingTick(recordingTimestamp, pending) {
  const [, forceTick] = useState(0);

  useEffect(() => {
    if (!pending) return undefined;
    const ms = toRecordingMs(recordingTimestamp);
    if (ms == null) return undefined;
    const remaining = ms + METRIC_PENDING_WINDOW_MS - Date.now();
    if (remaining <= 0) return undefined;
    const timer = setTimeout(
      () => forceTick((tick) => tick + 1),
      remaining + 250,
    );
    return () => clearTimeout(timer);
  }, [recordingTimestamp, pending]);
}
